import {
    ApolloClient,
    ApolloLink,
    InMemoryCache,
    createHttpLink
} from '@apollo/client';
import { toast } from 'react-toastify';
import { GraphQLError } from 'graphql';
import { onError } from '@apollo/client/link/error';
import ApolloLinkTimeout from 'apollo-link-timeout';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';

import { errorHandler } from '@utils/errors';
import { getCookie } from '@utils/cookie';

const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
        graphQLErrors.forEach((error) => {
            const { message, locations, path } = error;

            console.info(
                `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(
                    locations
                )}, Path: ${path}`
            );
            errorHandler(error as GraphQLError);
        });
    }

    if (networkError) {
        console.info(`[Network error]: ${networkError}`);
        if (networkError.message === 'Timeout exceeded') {
            toast.error('요청 시간이 지났습니다. 잠시후 다시 시도해주세요.');
        }
    }
});

const timeoutLink = new ApolloLinkTimeout(30000);
const httpLink = createHttpLink({ uri: '' });
const timeoutHttpLink = timeoutLink.concat(httpLink);

const uploadLink = createUploadLink({
    uri: '',
    credentials: 'include',
    headers: {
        Authorization: getCookie('HMT') ? `Bearer ${getCookie('HMT')}` : '',
        'Apollo-Require-Preflight': 'true'
    }
}) as unknown as ApolloLink;

const link = ApolloLink.from([
    errorLink,
    timeoutHttpLink,
    uploadLink as ApolloLink
]);

const client = new ApolloClient({
    link: link,
    connectToDevTools: true,
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'no-cache'
        }
    },
    cache: new InMemoryCache()
});

export default client;
